import React from 'react';
import styled from 'styled-components';
import {Tabs} from 'components/antd';
import {Container as DndContainer} from 'react-smooth-dnd';
import Button from './Button';
import Config from './Config';

type BlockType =
  | 'header'
  | 'title'
  | 'text'
  | 'image'
  | 'button'
  | 'divider'
  | 'footer';

export default () => {
  const [tab, setTab] = React.useState('add');

  return (
    <Container>
      <Tabs defaultActiveKey={tab} onChange={setTab}>
        <Tabs.TabPane tab="コンテンツを追加" key="add" />
        <Tabs.TabPane tab="全体" key="config" />
      </Tabs>
      {tab === 'add' && (
        <Buttons>
          <DndContainer
            groupName="mail-blocks"
            behaviour="copy"
            orientation="vertical"
            getChildPayload={(i: number): {type: BlockType} => ({
              type: [
                'header',
                'title',
                'text',
                'image',
                'button',
                'divider',
                'footer',
              ][i] as BlockType,
            })}
            dragClass="dragging">
            <Button type="header" text="ヘッダー" />
            <Button type="title" text="見出し" />
            <Button type="text" text="テキスト" />
            <Button type="image" text="画像" />
            <Button type="button" text="ボタン" />
            <Button type="divider" text="区切り線" />
            <Button type="footer" text="フッター" />
          </DndContainer>
        </Buttons>
      )}
      {tab === 'config' && <Config />}
    </Container>
  );
};

const Container = styled.div`
  .ant-tabs-nav-list {
    width: 100%;
  }
  .ant-tabs-tab {
    width: 50%;
    justify-content: center;
  }
`;

const Buttons = styled.div`
  .smooth-dnd-container {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }
`;
